"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readOnlyReasonProp = exports.objectCategoryProp = exports.listProp = exports.orderedMapProp = exports.mapProp = exports.SUPPORTED_UI_DROP_ZONE_PROPS = exports.FILE_UPLOAD_V3_OPTION_KEYS = exports.FileUploadOptionsPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

var _Constants = require("../Constants");

var ReadOnlyReason = _interopRequireWildcard(require("../enums/ReadOnlyReason"));

var TTL_OPTIONS = ['P1Y', 'P12M', 'P6M', 'P1D', 'P8W', 'P52W'];

var FileUploadOptionsPropType = _propTypes.default.exact({
  ttl: _propTypes.default.oneOf(TTL_OPTIONS),
  folderId: _propTypes.default.number,
  folderPath: _propTypes.default.string,
  overwrite: _propTypes.default.bool
});

exports.FileUploadOptionsPropType = FileUploadOptionsPropType;
var FILE_UPLOAD_V3_OPTION_KEYS = ['ttl', 'folderId', 'folderPath', 'overwrite'];
exports.FILE_UPLOAD_V3_OPTION_KEYS = FILE_UPLOAD_V3_OPTION_KEYS;
var SUPPORTED_UI_DROP_ZONE_PROPS = ['className', 'children', 'contentClassName', 'iconName', 'iconSize', 'size', 'use'];
exports.SUPPORTED_UI_DROP_ZONE_PROPS = SUPPORTED_UI_DROP_ZONE_PROPS;

var mapProp = _propTypes.default.instanceOf(_immutable.Map);

exports.mapProp = mapProp;

var orderedMapProp = _propTypes.default.instanceOf(_immutable.OrderedMap);

exports.orderedMapProp = orderedMapProp;

var listProp = _propTypes.default.instanceOf(_immutable.List);

exports.listProp = listProp;

var objectCategoryProp = _propTypes.default.oneOf(Object.values(_Constants.ObjectCategory));

exports.objectCategoryProp = objectCategoryProp;

var readOnlyReasonProp = _propTypes.default.oneOf(Object.values(ReadOnlyReason));

exports.readOnlyReasonProp = readOnlyReasonProp;